import { render, staticRenderFns } from "./IndicatorExplanationTooltip.vue?vue&type=template&id=656b8efc&scoped=true"
import script from "./IndicatorExplanationTooltip.vue?vue&type=script&lang=js"
export * from "./IndicatorExplanationTooltip.vue?vue&type=script&lang=js"
import style0 from "./IndicatorExplanationTooltip.vue?vue&type=style&index=0&id=656b8efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656b8efc",
  null
  
)

export default component.exports